import { DEFAULT_LIVE_MAP_DISPLAY_MODE } from "../../constants";
import { LiveMapDisplayModeEnum } from "../../enums";

const LIVE_MAP_DISPLAY_MODE_VALUES = new Set<string>(
  Object.values(LiveMapDisplayModeEnum),
);

export const isLiveMapDisplayMode = (
  value: unknown,
): value is LiveMapDisplayModeEnum =>
  typeof value === "string" && LIVE_MAP_DISPLAY_MODE_VALUES.has(value);

export const isLiveMapReducedDisplayMode = (
  mode: LiveMapDisplayModeEnum,
): boolean => mode === LiveMapDisplayModeEnum.noDrivePath;

export const isLiveMapFullDisplayMode = (
  mode: LiveMapDisplayModeEnum,
): boolean => mode === LiveMapDisplayModeEnum.stationPins;

/** i18n key shared with system-param select list (`selectListLabel.*`). */
export const liveMapDisplayModeTranslationKey = (
  mode: LiveMapDisplayModeEnum,
): string => `selectListLabel.${mode}`;

/** Resolves active mode: session override → system param → hardcoded fallback. */
export const resolveLiveMapDisplayMode = ({
  overrideValue,
  systemParamValue,
  fallback = DEFAULT_LIVE_MAP_DISPLAY_MODE,
}: {
  overrideValue?: LiveMapDisplayModeEnum;
  systemParamValue?: LiveMapDisplayModeEnum;
  fallback?: LiveMapDisplayModeEnum;
}): LiveMapDisplayModeEnum => {
  if (overrideValue && isLiveMapDisplayMode(overrideValue)) {
    return overrideValue;
  }

  if (systemParamValue && isLiveMapDisplayMode(systemParamValue)) {
    return systemParamValue;
  }

  return fallback;
};
